var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchHeader = function SvgSearchHeader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 18.7027C12.67 18.7027 14.3152 18.0987 15.6272 17.0991L19.2299 20.7018C19.4381 20.9101 19.7088 21.0142 19.9587 21.0142C20.2086 21.0142 20.5002 20.9101 20.6876 20.7018C21.1041 20.2853 21.1041 19.6398 20.6876 19.2233L17.1057 15.6206C18.1053 14.3086 18.7092 12.6634 18.7092 10.8933C18.7092 6.58257 15.2107 3.08398 10.8999 3.08398C6.58916 3.08398 3.09058 6.58257 3.09058 10.8933C3.09058 15.2041 6.58916 18.7027 10.8999 18.7027ZM10.8999 5.16647C14.0445 5.16647 16.6268 7.72794 16.6268 10.8933C16.6268 14.0587 14.0445 16.6202 10.8999 16.6202C7.75535 16.6202 5.17307 14.0379 5.17307 10.8933C5.17307 7.74876 7.73453 5.16647 10.8999 5.16647Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_header.c1f654f7.svg";
export { ForwardRef as ReactComponent };